export default "<customizable-dashboard [dashboardName]=\"dashboardName\"></customizable-dashboard>\r\n"